import React from "react";
import PropTypes from "prop-types";
import imageFile from "../../../../../assets/images/image-placeholder.png";

import styles from "./DragAndDropImage.module.scss";
import i18n from "i18n";

export class DragAndDropImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: this.props.file ? this.getUrl(this.props.file) : null,
      drag: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  dropRef = React.createRef();

  getUrl(file) {
    if (this.props.error) return;
    if (typeof (file) === 'string' && file.startsWith("http")) return file;
    return URL.createObjectURL(file);
  }

  handleChange(event) {
    this.setState({
      file: URL.createObjectURL(event.target.files[0]),
    });

    if (this.props.handleChange) this.props.handleChange(event);
  }

  handleDelete(event) {
    this.setState({
      file: null,
    });

    if (this.props.handleDelete) this.props.handleDelete(event);
  }

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter++;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  };

  handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.setState({ drag: false });
    }
  };

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      drag: false,
      file: URL.createObjectURL(e.dataTransfer.files[0]),
    });

    if (this.props.handleChange)
      this.props.handleChange({
        target: {
          name: this.props.name,
          type: "file",
          files: e.dataTransfer.files,
        },
      });

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      // this.props.handleDrop(e.dataTransfer.files);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  };

  componentDidMount() {
    let div = this.dropRef.current;
    div.addEventListener("dragenter", this.handleDragIn);
    div.addEventListener("dragleave", this.handleDragOut);
    div.addEventListener("dragover", this.handleDrag);
    div.addEventListener("drop", this.handleDrop);
  }

  componentWillUnmount() {
    let div = this.dropRef.current;
    div.removeEventListener("dragenter", this.handleDragIn);
    div.removeEventListener("dragleave", this.handleDragOut);
    div.removeEventListener("dragover", this.handleDrag);
    div.removeEventListener("drop", this.handleDrop);
  }

  render() {
    const { name, isSmall } = this.props;

    return (
      <div className={
        styles["drag-and-drop-image-container"] + (isSmall ? ' ' + styles["small"] : "")
      }>
        <div className={styles["drag-and-drop-image-wrapper"]} ref={this.dropRef}>
          {!this.state.file && (
            <div className={styles["drag-and-drop-image-input-wrapper"]}>
              <img src={imageFile} alt="product" />

              <div className={styles["drag-and-drop-image-text-wrapper"]}>
                <div className={styles["drag-and-drop-image-text"]}>
                  {i18n.t("drag.image.here")}
                </div>
                <div className={styles["drag-and-drop-image-text"]}>{i18n.t("or")}</div>
              </div>

              <label className={styles["custom-file-upload"]}>
                {i18n.t("select.here")}
                <input
                  type="file"
                  name={name}
                  accept="image/png, image/jpeg"
                  onChange={this.handleChange}
                ></input>
              </label>
              <label className={styles["drag-and-drop-image-help"]}>
                ({i18n.t("max.size.file", { MAX_FILE_SIZE_MB: 1 })})
              </label>
            </div>
          )}

          {!this.state.file && (
            <div className={styles["drag-and-drop-image-input-wrapper-mobile"]}>
              <label className={styles["custom-file-upload"]} htmlFor="mobile-input-file">
                <div className={styles["custom-file-wrapper"]}>
                  <img src={imageFile} alt="product" />
                </div>
              </label>
              <input
                type="file"
                id="mobile-input-file"
                name={name}
                accept="image/png, image/jpeg"
                onChange={this.handleChange}
              ></input>

              <div className={styles["drag-and-drop-bottom-label"]}>
                <label
                  className={styles["drag-and-drop-bottom-label-add"]}
                  htmlFor="mobile-input-file"
                >
                  {i18n.t("add.image")}
                </label>
                <label className={styles["drag-and-drop-image-help"]}>
                ({i18n.t("max.size.file", { MAX_FILE_SIZE_MB: 1 })})
                </label>
              </div>
            </div>
          )}

          {this.state.file && (
            <div className={styles["drag-and-drop-image-input-preview"]}>
              <img src={this.state.file} alt="product" />
              <div
                className={styles["drag-and-drop-image-delete"]}
                onClick={this.handleDelete}
                data-automation-id="delete-image"
              >
                <i className="icon-iconos_eliminar"></i>
                {i18n.t("remove")}
              </div>
            </div>
          )}

          {this.props.error && (
            <div className={styles["drag-and-drop-image-error"]}>{this.props.error}</div>
          )}
        </div>
      </div>
    );
  }
}

DragAndDropImage.propTypes = {
  handleChange: PropTypes.func,
};

export default DragAndDropImage;
